export enum ConversationCategory {
    Coaching,
    Guides,
    Population
}
